<template>
    <div
        class="app-banner"
        :class="{ 'localhost-banner': showLocalhostBanner }"
    >
        <div>
            <span class="app-banner-text">
                <template v-if="$userStore.isViewOnly">
                    You are currently using a View-Only Account of the IPAC
                    Dashboard.
                    <router-link
                        v-if="$userStore.isCompanyAdmin"
                        :to="billingRoute"
                        class="upgrade-link"
                    >
                        Upgrade your plan today!
                    </router-link>
                </template>
                <template v-else>
                    You are currently using the IPAC Dashboard Local Environment
                </template>
            </span>
        </div>

        <div
            v-if="!$userStore.isViewOnly"
            class="close-button"
            @click="closeBanner"
        >
            <i class="fi fi-x"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppBanner',
    emits: ['close'],
    data() {
        return {
            billingRoute: {
                name: 'Settings',
                query: { tab: 'billing' },
                hash: '#manage-plan',
            },
        };
    },
    computed: {
        isLocalhost() {
            return this.$env.environment === 'development';
        },
        showLocalhostBanner() {
            return this.isLocalhost && !this.$userStore.isViewOnly;
        },
    },
    methods: {
        closeBanner() {
            this.$emit('close');
        },
    },
};
</script>

<style scoped>
.close-button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.25rem 0.6rem;
    z-index: 9999;
}

.close-button:hover {
    cursor: pointer;
}

.app-banner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    height: 2rem;
    background: var(--primary-500);
    color: white;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.localhost-banner {
    background: var(--success);
}

.app-banner-text {
    font-weight: 700;
    font-size: var(--size-3);
    line-height: 1;
}

.upgrade-link {
    color: var(--secondary-500);
    text-decoration: underline;
    cursor: pointer;
    font-weight: 700;
    font-size: var(--size-3);
    line-height: 1;
}

.upgrade-link:hover {
    color: var(--white);
}

@media only screen and (max-width: 767.98px) {
    .app-banner {
        height: 3rem;
    }
}
</style>
